// class names
export const boxPlotClassName = 'box-plot';

// test ids
export const testIdBoxPlot = 'testIdBoxPlot';
export const testIdBoxPlotItem = 'testIdBoxPlotItem';
export const testIdBoxPlotNoData = 'testIdBoxPlotNoData';
export const testIdBoxPlotLegend = 'testIdBoxPlotLegend';
